export default {
    paths: [], // 路由列表
};


// WEBPACK FOOTER //
// ./src/store/state.js